import { Component } from '@angular/core';
import { BeLogoV2Component } from '../../feature-modules/shared/components/be-logo-v2/be-logo-v2.component';
import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'app-header-nav-skeleton',
    templateUrl: './header-nav-skeleton.component.html',
    styleUrls: ['./header-nav-skeleton.component.scss'],
    imports: [BeLogoV2Component]
})
export class HeaderNavSkeletonComponent {
  constructor(private readonly authService: AuthService) {}

  logOut() {
    this.authService.logOut();
  }
}
